import { render } from "./ParentStatus.vue?vue&type=template&id=3c9a80ee"
import script from "./ParentStatus.vue?vue&type=script&lang=js"
export * from "./ParentStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__